import { Component } from '@angular/core';

@Component({
    selector: 'app-user-recommended-session',
    templateUrl: './user-recommended-session.component.html',
    styleUrls: ['./user-recommended-session.component.scss'],
    standalone: false
})
export class UserRecommendedSessionComponent {

}
